/**
 * The router state the bar's Schedule slot navigates with: back to today AND back to the Staff tab (APP-886). The tab is
 * the home's own state, which survives a navigation that keeps the home mounted, so the home reads this to reset it.
 */
export const GAPS_HOME_RESET_STATE = { gapsHomeReset: true } as const;

/** Whether a location's state is the Schedule slot's reset (`GAPS_HOME_RESET_STATE`). */
export const isGapsHomeReset = (state: unknown): boolean =>
	typeof state === "object" && state !== null && "gapsHomeReset" in state && state.gapsHomeReset === true;
